<template>
  <div>
    <div class="card-title mb-3">
      {{ $t("role.planning.closing_days.title") }}
    </div>
    <p>
      {{ $t("role.planning.closing_days.desc") }}
    </p>
    <div class="row">
      <div class="col">
        <CInputCheckbox
          :label="$t('common.days.mon')"
          inline
          custom
          :checked.sync="closing_days.Mon"
        />
      </div>
      <div class="col">
        <CInputCheckbox
          :label="$t('common.days.tue')"
          inline
          custom
          :checked.sync="closing_days.Tue"
        />
      </div>
      <div class="col">
        <CInputCheckbox
          :label="$t('common.days.wed')"
          inline
          custom
          :checked.sync="closing_days.Wed"
        />
      </div>
      <div class="col">
        <CInputCheckbox
          :label="$t('common.days.thu')"
          inline
          custom
          :checked.sync="closing_days.Thu"
        />
      </div>
      <div class="col">
        <CInputCheckbox
          :label="$t('common.days.fri')"
          inline
          custom
          :checked.sync="closing_days.Fri"
        />
      </div>
      <div class="col">
        <CInputCheckbox
          :label="$t('common.days.sat')"
          inline
          custom
          :checked.sync="closing_days.Sat"
        />
      </div>
      <div class="col">
        <CInputCheckbox
          :label="$t('common.days.sun')"
          inline
          custom
          :checked.sync="closing_days.Sun"
        />
      </div>
      <div class="col">
        <CButton
          size="sm"
          color="primary"
          block
          :disabled="hasChanged"
          @click="onModalOpen"
          ><b>{{ $t("common.editor.button.saveEdited") }}</b></CButton
        >
        <CModal
          :title="$t('role.planning.closing_days.modal.title')"
          :show.sync="modalShow"
          :closeOnBackdrop="false"
          :centered="true"
        >
          <p>
            {{ $t("role.planning.closing_days.modal.subtitle") }}
          </p>
          <p>
            {{ $t("role.planning.closing_days.modal.text") }}
          </p>
          <template #footer>
            <CButton color="primary" @click="onModalConfirm">{{
              $t("common.editor.button.confirm")
            }}</CButton>
            <CButton color="primary" variant="outline" @click="onModalClose">{{
              $t("common.editor.button.cancel")
            }}</CButton>
          </template>
        </CModal>
      </div>
    </div>
    <hr />

    <CRow>
      <CCol sm="6">
        <div class="card-title mb-3">
          {{ $t("role.planning.closing.title") }}
        </div>
      </CCol>
      <CCol sm="6" class="justify-content-end d-flex">
        <div>
          <CButton color="primary" class="mb-3" @click="addClosing()">
            <font-awesome-icon icon="plus" class="mr-2" />
            {{ $t("role.planning.closures.addClosure") }}
          </CButton>
        </div>
      </CCol>
    </CRow>

    <CRow v-if="closureData" class="p-3">
      <div v-if="closureData.length > 0" class="w-100">
        <Header
          :data="[
            $t('role.planning.closing.name'),
            $t('role.planning.closing.from'),
            $t('role.planning.closing.until'),
            'Actions',
          ]"
        />
        <Row
          v-for="(item, index) in closureData"
          :key="index"
          :data="[
            { data: item.name, type: 'text' },
            { data: formatDate(item.start), type: 'text' },
            { data: formatDate(item.end), type: 'text' },
            { data: '', type: 'actions' },
          ]"
          :border="true"
          :topAligned="true"
        >
          <template #actions>
            <div class="d-flex justify-content-end">
              <CButton
                class="mr-2 mt-2"
                size="sm"
                color="primary"
                @click="editClosing(item)"
              >
                <font-awesome-icon icon="edit" />
              </CButton>

              <CButton
                class="mr-2 mt-2"
                size="sm"
                color="primary"
                @click="removeClosing(item.id)"
              >
                <font-awesome-icon icon="trash-alt" />
              </CButton>
            </div>
          </template>
        </Row>
      </div>
      <div v-else>
        {{ $t("role.planning.closures.noClosures") }}
      </div>
    </CRow>

    <ClosingModal
      :show.sync="modal.show"
      :title="modal.title"
      :values="modal.values"
      :edit-mode="modal.editMode"
      :edit-id="modal.editId"
      @submitted="fetchData"
    />
  </div>
</template>
<script>
import { apiGet, apiPatch, apiDelete } from "../../../helpers/apiHelper";
import Row from "../../../common/table/Row.vue";
import Header from "../../../common/table/Header.vue";
import ClosingModal from "./ClosingModal.vue";

export default {
  components: {
    Row,
    Header,
    ClosingModal,
  },
  data() {
    let closing_days = {};
    return {
      closureData: [],
      modalShow: false,
      closing_days: closing_days,
      modal: {
        show: false,
        title: "",
        values: {},
        editMode: false,
        editId: null,
      },
    };
  },
  async created() {
    this.closing_days = { ...this.$store.state.role.closing_days };
    await this.fetchData();
  },
  watch: {
    "$store.state.role.closing_days": {
      handler(newVal) {
        if (newVal) {
          this.closing_days = { ...newVal };
        }
      },
      deep: true,
    },
  },
  computed: {
    hasChanged() {
      return (
        JSON.stringify(this.closing_days) ===
        JSON.stringify(this.$store.state.role.closing_days)
      );
    },
  },
  methods: {
    formatDate(dateStr) {
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      const date = new Date(dateStr);
      return date.toLocaleDateString(undefined, options);
    },

    addClosing() {
      this.modal.title = this.$t("role.planning.closures.addClosure");
      this.modal.values = {};
      this.modal.editMode = false;
      this.modal.editId = null;
      this.modal.show = true;
    },
    editClosing(item) {
      this.modal.title = this.$t("role.planning.closures.editClosure");
      this.modal.values = item;
      this.modal.editMode = true;
      this.modal.editId = item.id;
      this.modal.show = true;
    },

    async removeClosing(id) {
      const response = await apiDelete("role_planningclose", id, [
        this.$store.state.role.id,
      ]);
      if (response && response.status === 200) {
        this.$store.dispatch("toaster/add", {
          title: "OK!",
          text: this.$t("role.planning.producer.removedMsg"),
          color: "success",
          autohide: true,
        });
        await this.fetchData();
      } else {
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error removing distributor",
          color: "danger",
          autohide: true,
        });
      }
    },

    async fetchData() {
      const response = await apiGet(
        "role_planningclose",
        [this.$store.state.role.id],
        null
      );
      if (response && response.status === 200) {
        this.closureData = response.data.payload.Items;
      } else {
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error loading planning data",
          color: "danger",
          autohide: true,
        });
      }
    },

    onModalOpen() {
      this.modalShow = true;
    },

    onModalClose() {
      this.modalShow = false;
    },

    async onModalConfirm() {
      const params = {
        id: this.$store.state.role.id,
        closing_days: this.closing_days,
      };

      const response = await apiPatch("auth_role", params.id, params, [
        this.$store.state.role.id,
      ]);

      if (response && response.status === 200) {
        // Update store with the new closing_days
        this.$set(this.$store.state.role, "closing_days", this.closing_days);
        this.$store.dispatch("toaster/add", {
          title: "OK!",
          text: this.$t("role.planning.closing_days.messages.ok"),
          color: "success",
          autohide: true,
        });
        this.modalShow = false;
      } else {
        this.$store.dispatch("toaster/add", {
          title: this.$t("common.editor.messages.ko.title"),
          text: this.$t("role.planning.closing_days.messages.ko"),
          color: "info",
          autohide: true,
        });
      }
    },
  },
};
</script>
